import { useEffect, useMemo } from "react";

import { Product } from "@transfr-inc/dashboard-components/constants";

import { trackClassroomPageViewed } from "@lib/event-trackers";
import { ProductTab } from "@views/shared/product-tab/product.tab";
import { TraineeClassroomProgTab } from "@views/users/trainee-detail/components/trainee.classroom.prog.tab";
import { TraineeClassroomTrekTab } from "@views/users/trainee-detail/components/trainee.classroom.trek.tab";
import { TraineeClassroomTsTab } from "@views/users/trainee-detail/components/trainee.classroom.ts.tab";

import { MyWorkCeTab } from "./my-work.ce.tab";

export function MyWorkTab({
  trainee,
  classroom,
  organization,
  onRemoveTrainee,
  removeTraineeEnabled,
  isPreview,
}) {
  const { products, id, name } = classroom;

  useEffect(() => {
    if (id && name) {
      trackClassroomPageViewed(id, name);
    }
  }, [id, name]);

  const productComponents = useMemo(() => {
    const componentsMap = {};

    products?.forEach((productCode) => {
      switch (productCode) {
        case Product.TS:
          componentsMap[Product.TS] = (
            <TraineeClassroomTsTab
              trainee={trainee}
              classroom={classroom}
              organization={organization}
              onRemoveTrainee={onRemoveTrainee}
              removeTraineeEnabled={removeTraineeEnabled}
              isPreview={isPreview}
            />
          );
          break;
        case Product.CE:
          componentsMap[Product.CE] = (
            <MyWorkCeTab
              trainee={trainee}
              classroom={classroom}
              onRemoveTrainee={onRemoveTrainee}
              removeTraineeEnabled={removeTraineeEnabled}
            />
          );
          break;
        case Product.TRK:
          componentsMap[Product.TRK] = (
            <TraineeClassroomTrekTab
              trainee={trainee}
              classroom={classroom}
              onRemoveTrainee={onRemoveTrainee}
              removeTraineeEnabled={removeTraineeEnabled}
            />
          );
          break;
        case Product.PROG:
          componentsMap[Product.PROG] = (
            <TraineeClassroomProgTab
              trainee={trainee}
              classroom={classroom}
              onRemoveTrainee={onRemoveTrainee}
              removeTraineeEnabled={removeTraineeEnabled}
            />
          );
          break;
        default:
          break;
      }
    });

    return componentsMap;
  }, [
    products,
    trainee,
    classroom,
    organization,
    onRemoveTrainee,
    removeTraineeEnabled,
  ]);

  return (
    <ProductTab
      name={name || "My Work"}
      productComponents={productComponents}
    />
  );
}
